import axios from 'axios'
import { SentimentData } from './interactionsummary.constants'

const INTERACTION_SUMMARY_ROUTE = '/api/rest/cas/interactionsummary'
const OVERALL_SENTIMENT_ROUTE = '/api/rest/cas/advancesentiment'

export const getInteractionSummary = (clientAppId: string, ccrId: number) => axios
  .get<{ summary: string }>(INTERACTION_SUMMARY_ROUTE, {
    params: {
      clientAppId,
      ccrId,
    },
  })
  .then(res => res.data)


export const getOverallSentiment = (ccrId: number) => axios
  .get<SentimentData>(OVERALL_SENTIMENT_ROUTE, {
    params: {
      ccrId,
    },
  })
  .then(res => res.data)

